<template>
  <div>
    <v-dialog v-model="dialog" width="500" :dark="$root.config.dark">
      <v-card>
        <v-card-title :class="['title', $root.colors.primary, 'white--text']" v-html="lang.settings" />
        <v-card-text>
          <v-container grid-list-md :class="['pa-0']">
            <v-layout row wrap>
              <v-flex xs12>
                <v-switch :color="$root.colors.primary" :label="lang.darkTheme" v-model="theme" hide-details :class="['ma-0']" />
              </v-flex>
              <v-flex xs12 v-html="lang.colorScheme" :class="['pb-2']" />
              <v-flex xs2 v-for="(config, color) in themeColors" :key="color">
                <v-card ripple raised dark :color="config.primary" :class="['color-item', 'item-clickable', getCurrentColor(config.primary) ? 'color-item-selected' : null]" @click="setColor(color)">
                  <v-card-text :class="['text-xs-center', 'pa-2']">
                    <v-icon>mdi-check</v-icon>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn small flat @click="deleteLocalDataDialog = true">{{ lang.deleteLocalData }}</v-btn>
          <v-spacer />
          <v-btn small :color="$root.colors.primary" @click="dialog = false" v-html="lang.close" dark />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteLocalDataDialog" width="400" :dark="$root.config.dark" persistent>
      <v-card>
        <v-card-title :class="['title', $root.colors.primary, 'white--text']" v-html="lang.deleteLocalData" />
        <v-card-text v-html="lang.deleteLocalDataDialogText" />
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn small flat @click="deleteLocalDataDialog = false" v-html="lang.no" />
          <v-btn small :color="$root.colors.primary" @click="deleteLocalData" v-html="lang.yes" dark />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import lang from '../helpers/lang'
import themeColors from '../helpers/theme-colors'
import events from '../helpers/events'
import methods from '../helpers/methods'

export default {
  name: 'SettingsDialog',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      themeColors,
      dialog: false,
      deleteLocalDataDialog: false,
      theme: this.$root.config.dark,
      color: this.$root.colors.primary
    }
  },
  created () {
    this.$root.$on(events.settings, (settings) => {
      this.dialog = settings.show
    })
  },
  watch: {
    /**
     * Watch for theme object changes and store the data locally
     */
    theme () {
      this.$root.config.dark = this.theme
      this.$nextTick(() => {
        this.storeLocalData()
      })
    }
  },
  methods: {
    /**
     * Select the color box if the color is equal to the currently selected theme color
     * @method getCurrentColor
     * @param {string|null} color [color=null]
     * @return {boolean}
     */
    getCurrentColor (color = null) {
      return this.$root.colors.primary === color
    },
    /**
     * Set theme color and proceed to store the data in the local storage
     * @method setColor
     * @param {string|null} color [color=null]
     * @return {void}
     */
    setColor (color = null) {
      this.$root.colors = this.themeColors[color]
      this.$nextTick(() => {
        this.storeLocalData()
      })
    },
    /**
     * Delete the locally stored site settings
     * @method deleteLocalData
     * @return {void}
     */
    deleteLocalData () {
      localStorage.removeItem(this.$root.config.localStorageEntryName)
      location.reload()
    },
    /**
     * Store the data in the local storage and reload the page
     * @method storeLocalData
     * @return {void}
     */
    storeLocalData () {
      const root = this.$root
      localStorage.setItem(root.config.localStorageEntryName, JSON.stringify({
        colors: root.colors,
        dark: root.config.dark
      }))
      this.setBreadcrumbsColor()
      if (root.config.reloadAppOnSettingsSave) {
        location.reload()
      }
    }
  }
}
</script>
<style>
.color-item .v-icon
{
  opacity: 0;
  transition: opacity .2s ease-in-out;
}

.color-item-selected .v-icon
{
  opacity: 1;
}

.color-item-selected.item-clickable
{
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// src/components/settings-dialog.vue